<template>
    <div id="suggest">
       <bread :content="breadContent"></bread>
       <p class="Page-title">献策车道</p>
       <el-divider></el-divider>
       <div id="form">
           <div class="a-line">
               <div class="input">
                   <span>姓名：</span>
                    <input type="text" class="input-line" v-model="data.Name">
               </div>
                <div class="input">
                    <span>职业：</span>
                    <input type="text" class="input-line" v-model="data.Profession">
                </div>
           </div>
           <div class="a-line">
            <div class="input">
                <span>电话：</span>
                <input type="text" class="input-line" v-model="data.Phone">
            </div>
           <div class="input">
                <span>单位：</span>
                <input type="text" class="input-line" v-model="data.From">
           </div>
           </div>
           <div id="mail" class="input">
               <span>邮箱：</span>
               <input type="text" class="input-line" v-model="data.Email"> 
           </div>
           <div class="input a-line">
               <span>标题：</span>
               <input type="text" class="input-line" v-model="data.Title">
           </div>
           <div class="a-line">
               <span class="mb15">正文：</span>
               <textarea class="text" v-model="data.Content"></textarea>
           </div>
           <div class="input">
               <span>验证码：</span>
               <input type="text" class="input-line" v-model="data.VerificationCodeAnswer">
               <img class="verImg" :src="data.VerificationCodeUrl" @click="getNewCode()">
           </div>
           <div id="center-button">
               <button @click="submit">提交</button>
           </div>
       </div>
       
       <div class="contact-mail">
         <div class="top">联系邮箱</div>
         <div class="bottom">
           <p title="点击打开邮件"><a :href="'Mailto:'+Email">{{Email}}</a></p>
         </div>
       </div>
    </div>
</template>
<script>
import bread from "@/components/bread";
export default {
  components: {
    bread
  },
  name: "suggest",
  async created() {
    this.data.VerificationCodeUrl = (await this.$net.getVeriCode()).VerificationCode;
    this.Email=(await this.$net.index.getMail());
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "献策车道", routerName: "suggest" }
      ],
      Email:'',
      imgUrl: "",
      data: {
        Name: "",
        Phone: "",
        Profession: "",
        From: "",
        Email: "",
        Title: "",
        Content: "",
        VerificationCodeUrl: "",
        VerificationCodeAnswer: ""
      }
    };
  },
  methods: {
    submit() {
      if (!this.judgeNull()) {
        alert("不能为空!");
        return;
      }
      this.$net.index.postSuggest(this.data).then((res) => {
        console.log(res)
        if (res.ErrorCode == 0) {
          alert("提交成功!");
          for (let key in this.data) {
            this.data[key] = "";
          }
        }
      })
    },
    judgeNull() {
      for (let key in this.data) {
        if (this.data[key] == "") {
          return 0;
        }
      }
      return 1;
    },
    async getNewCode() {
      this.data.VerificationCodeUrl = (await this.$net.getVeriCode()).VerificationCode;
    }
  }
};
</script>
  
<style lang="scss" scoped>
#suggest {
  width: 70%;
  margin-left: 15%;
  margin-top: 80px;
  margin-bottom: 200px;
  span {
    white-space: nowrap;
  }
  span:before {
    content: "*  ";
    color: red;
  }
  #form {
    margin:60px 15% 0 15%;
    display: flex;
    flex-direction: column;
    font-size: 24px;
    color: #333333;
  }
  .a-line {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  #mail {
    margin-bottom: 85px;
  }
}
.input {
  width: 45%;
  display: flex;
}
.input-line {
  padding: 0 12px;
  background: rgba(0, 0, 0, 0);
  border: none;
  flex: 1;
  border-bottom: 1px rgb(199, 199, 199) solid;
  font-size: 24px;
  overflow: hidden;
  color: #333;
}
.text {
  width: 100%;
  height: 300px;
  padding: 10px;
}
button {
  margin-top: 50px;
  width: 200px;
  height: 45px;
  background-color: rgba(51, 159, 220, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(170, 170, 170, 1);
  border-radius: 3px;
  font-size: 20px;
  color: #ffffff;
  cursor: pointer;
}
#center-button {
  text-align: center;
}
img {
  height: 35px;
}
.verImg{
  margin-left: 20px;
}
.contact-mail {
  position: absolute;
  right: 0;
  top: 500px;
  width: 200px;
  font-size: 24px;
  border: 1px solid #ccc;
  .top {
    background-color: #005da2;
    text-align: center;
    height: 64px;
    line-height: 64px;
    color: #fff;
  }
  .bottom {
    display: flex;
    align-items: center;
    height: 100px;
    padding: 0 10px;
    text-align: center;
    color: #333;
    p {
      font-size: 20px;
      word-break: break-all; 
    }
  }
}

.mb15 {
  margin-bottom: 15px;
}
</style>

